module.exports = __webpack_public_path__ + "img/7_147.228961f1.png";